import { Routes } from "@angular/router";
import { LvfMissionType } from "@kiraah-shared/common";
import {
  MOBILE_MISSION_LIST_LVF_TYPES,
  MOBILE_MISSION_TASK_ROUTE_SEGMENTS,
  type MobileMissionTaskRouteSegments,
} from "./mobile-mission-task-route.provider";

/** Routes enfants (relatives au préfixe `tasks`, `chantier/missions` ou `eprojet/projets`). */
const authenticatedMissionTaskChildRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadComponent: () =>
      import("./mobile-mission-list-page/mobile-mission-list-page.component").then(
        (moduleExports) => moduleExports.MobileMissionListPageComponent,
      ),
  },
  {
    path: ":missionUid/t/:taskUid/chat",
    loadComponent: () =>
      import("./mobile-task-chat-page/mobile-task-chat-page.component").then(
        (moduleExports) => moduleExports.MobileTaskChatPageComponent,
      ),
  },
  {
    path: ":missionUid/t/:taskUid",
    loadComponent: () =>
      import("./mobile-task-edit-page/mobile-task-edit-page.component").then(
        (moduleExports) => moduleExports.MobileTaskEditPageComponent,
      ),
  },
  {
    path: ":missionUid/info",
    loadComponent: () =>
      import("./mobile-mission-info-page/mobile-mission-info-page.component").then(
        (moduleExports) => moduleExports.MobileMissionInfoPageComponent,
      ),
  },
  {
    path: ":missionUid/voice-report",
    loadComponent: () =>
      import("../voice-report/mobile-voice-report-workflow-page/mobile-voice-report-workflow-page.component").then(
        (moduleExports) => moduleExports.MobileVoiceReportWorkflowPageComponent,
      ),
  },
  {
    path: ":missionUid/voice-purchase-request/result/:sessionUid/providers",
    loadComponent: () =>
      import("../voice-purchase-request/mobile-voice-purchase-request-providers-page/mobile-voice-purchase-request-providers-page.component").then(
        (m) => m.MobileVoicePurchaseRequestProvidersPageComponent,
      ),
  },
  {
    path: ":missionUid/voice-purchase-request/result/:sessionUid",
    loadComponent: () =>
      import("../voice-purchase-request/mobile-voice-purchase-request-result-page/mobile-voice-purchase-request-result-page.component").then(
        (m) => m.MobileVoicePurchaseRequestResultPageComponent,
      ),
  },
  {
    path: ":missionUid/voice-purchase-request",
    loadComponent: () =>
      import("../voice-purchase-request/mobile-voice-purchase-request-workflow-page/mobile-voice-purchase-request-workflow-page.component").then(
        (m) => m.MobileVoicePurchaseRequestWorkflowPageComponent,
      ),
  },
  {
    path: ":missionUid",
    loadComponent: () =>
      import("./mobile-mission-detail-page/mobile-mission-detail-page.component").then(
        (moduleExports) => moduleExports.MobileMissionDetailPageComponent,
      ),
  },
];

export function missionTaskShellRoutes(
  navSegments: MobileMissionTaskRouteSegments,
  missionLvfTypes: readonly LvfMissionType[],
): Routes {
  return [
    {
      path: "",
      providers: [
        { provide: MOBILE_MISSION_TASK_ROUTE_SEGMENTS, useValue: navSegments },
        { provide: MOBILE_MISSION_LIST_LVF_TYPES, useValue: missionLvfTypes },
      ],
      children: authenticatedMissionTaskChildRoutes,
    },
  ];
}

/** Parcours E-Audit → préfixe `/mobile/eaudit/missions`, types audit + conseil. */
export const authenticatedMissionTaskRoutes = missionTaskShellRoutes(["eaudit", "missions"], [
  LvfMissionType.AUDIT,
  LvfMissionType.CONSULTING,
]);

/** Parcours chantier BTP → préfixe `/mobile/chantier/missions`, type BTP uniquement. */
export const authenticatedMissionTaskChantierRoutes = missionTaskShellRoutes(["chantier", "missions"], [
  LvfMissionType.BTP,
]);

/** E-Projet → préfixe `/mobile/eprojet/projets`, missions conseil uniquement. */
export const authenticatedMissionTaskProjectRoutes = missionTaskShellRoutes(["eprojet", "projets"], [
  LvfMissionType.CONSULTING,
]);
